// extracted by mini-css-extract-plugin
module.exports = {"card":"section-card_card__kLuXa","card--complete":"section-card_card--complete__2Xz1I","card--next":"section-card_card--next__u8jG2","title":"section-card_title__Rod5l"};